import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { portfolio } from "../data/portfolio";

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="scroll-mt-24 bg-[#1C1C19] text-[#F7F5F0] py-24 md:py-40"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 mb-16 md:mb-20">
          <div className="md:col-span-3 reveal">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#F2C14E]">
              (04) · Selected work
            </span>
            <div className="mt-6 w-12 h-px bg-[#F2C14E]" />
          </div>
          <div className="md:col-span-9 reveal">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight leading-[1.05]">
              Work in
              <br />
              <span className="italic text-[#F2C14E]">motion.</span>
            </h2>
            <p className="mt-8 max-w-2xl text-base md:text-lg font-light text-[#F7F5F0]/70">
              A small, intentional set of engagements, described by the
              problem, the approach and where they stand today. We identify
              partners by sector, not by name.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-start">
          {portfolio.map((p, i) => (
            <Link
              to={`/portfolio/${p.slug}`}
              key={p.slug}
              data-testid={`portfolio-card-${i + 1}`}
              className="reveal group flex flex-col"
            >
              {/* Image block — fixed aspect so both cards align; only badge + arrow overlay it */}
              <div className="relative aspect-[16/11] overflow-hidden rounded-2xl bg-[#2A3439]">
                <img
                  src={p.cover}
                  alt={p.sector}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C19]/50 to-transparent" />
                <div
                  className="absolute top-4 left-4 px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.25em] font-bold"
                  style={{
                    backgroundColor: p.accent,
                    color: p.accent === "#F2C14E" ? "#1C1C19" : "#F7F5F0",
                  }}
                >
                  {p.sector}
                </div>
                <div className="absolute top-4 right-4 flex items-center justify-center w-10 h-10 rounded-full bg-[#F7F5F0]/15 backdrop-blur-md border border-[#F7F5F0]/30 text-[#F7F5F0] transition-all duration-500 group-hover:bg-[#F7F5F0] group-hover:text-[#1C1C19] group-hover:rotate-45">
                  <ArrowUpRight size={18} />
                </div>
              </div>

              {/* Text block — below the image, normal flow, never overlaps */}
              <div className="pt-6">
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#F2C14E]">
                  {p.engagementType}
                </span>
                <h3 className="mt-3 font-display text-2xl md:text-4xl font-light tracking-tight leading-tight">
                  {p.problem}
                </h3>
                {p.result ? (
                  <div className="mt-4">
                    <div className="text-[10px] uppercase tracking-[0.25em] text-[#F7F5F0]/50">
                      Result
                    </div>
                    <div className="mt-1 font-display text-2xl md:text-3xl font-light tracking-tight text-[#F2C14E]">
                      {p.result}
                    </div>
                  </div>
                ) : (
                  <p className="mt-4 text-sm md:text-base text-[#F7F5F0]/70 font-light">
                    {p.currentStage}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16 flex justify-center reveal">
          <a
            href="#contact"
            data-testid="portfolio-view-all"
            className="btn-magnetic inline-flex items-center gap-3 px-7 py-4 rounded-full border border-[#F7F5F0]/40 text-sm uppercase tracking-widest hover:bg-[#F7F5F0] hover:text-[#1C1C19]"
          >
            Want to work with us?
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
